import React, {useContext, useEffect} from "react";
import '../ClientInvoice/ClientInvoice.css'
import parse from "html-react-parser";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import PrintInvoice1 from "../ClientInvoice/PrintInvoice1";
import BackToEstimate from "../ClientInvoice/BackToEstimate";

// used to show the terms and conditions of the company when Digital Invoice is present of the estimate.
export default () => {
    let Record = useContext(RecordsManagementContext)
    let InvoiceType = Record.IV1_PageDetails.InvoiceType
    let IV1_PageDetails
    InvoiceType === undefined ?  IV1_PageDetails = Record.IV2_PageDetails : IV1_PageDetails = Record.IV1_PageDetails
    let backgroundColor1 = InvoiceType === undefined ? IV1_PageDetails.CompanyBranchAndEstimateInfo.BgColor1 : IV1_PageDetails.BackgroundColor.BgColor1
    let backgroundColor2 = InvoiceType === undefined ? IV1_PageDetails.CompanyBranchAndEstimateInfo.BgColor2 : IV1_PageDetails.BackgroundColor.BgColor2
    let Conditions = IV1_PageDetails.CompanyTermsAndConditions
    let PageView = useContext(ViewMangementContext)
    const ShowFrontPage = () => { // set the page view (either Invoice or 2 )
        InvoiceType === undefined ?
            PageView.Set('INVOICE_2') : PageView.Set('INVOICE_1')
    }
    useEffect(() => {//when scroll the page down the page's header still show on the page .
        window.addEventListener('scroll', stickyHead);
        return () => {
            window.removeEventListener('scroll', stickyHead);
        };
    });
    const stickyHead = (e) => {//to make the page's header sticky.
        const header = document.querySelector('.sticky-head');
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'top: 0; border-bottom: #17a2b8 2px solid !important;margin-left:-23px;')  : header.setAttribute('style', 'top: 0; border-bottom: 0px; margin-left:-23px');
    };
    return (
        <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className='width-wrapper px-4'>
                <table className="table">
                    <thead className="sticky-head" style={{ top: 0,marginLeft: "-23px"}}>
                    <tr>
                        <th className="th-main-bost">
                            <table className="table">
                                <tbody>
                                <tr>
                                    <td className="td-main-bost">
                                        <BackToEstimate/>
                                    </td>
                                    <td className="td-main-bost" style={{textAlign: "center"}}>
                                        This Estimate is Booked For - {IV1_PageDetails.ServiceDate}
                                    </td>
                                    <td className="td-main-bost" style={{float: "right",paddingLeft:"42px"}}>
                                        <PrintInvoice1/>&nbsp;&nbsp;
                                        <button  className='btn btn-dark btn-sm' onClick={()=> ShowFrontPage()}>
                                            <b>SHOW FRONT PAGE</b></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="td-main-bost set-pid" style={{textAlign: "center"}} colSpan={4}>
                            <h6> {IV1_PageDetails.CurrentCompany} TERMS AND CONDITIONS </h6>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost terms-text" colSpan={4}>
                            {Conditions.map((text,i) => {
                                return (
                                    <>
                                        <h6><u>{i+1}. {text.heading}</u></h6>
                                        <p style={{textAlign: "justify"}}>{parse(text.content)}</p><br/>
                                    </>
                                )
                            })
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}